import Store from './Store'

export default Store